import { isEmpty } from "lodash-es"
import { questionList } from "utils/formDataHelpers"
import { evaluateBranchingConditionals, evaluateSectionBranchingConditionals } from "utils/QuestionBranching"

const answerHasValue = (answer) => !isEmpty(answer) || typeof answer === "number"

// Mirrors the checks the submission edit form makes when rendering a question:
// the first section is always shown, and a question in a shown section is
// shown when its own branching conditions are met.
const questionIsShown = ({
  answers, operatorData, question, section, sectionIndex,
}) => {
  const sectionIsShown = sectionIndex === 0 || evaluateSectionBranchingConditionals({
    formAnswers: answers,
    operatorData,
    section,
  })

  if (!sectionIsShown) return false

  return evaluateBranchingConditionals({
    conditionals: question.conditionals,
    formAnswers: answers,
    operatorData,
  })
}

const shownQuestionUuids = ({ answers, formVersion, operatorData }) => {
  const { sections = [] } = formVersion

  return sections.reduce((questionUuids, section, sectionIndex) => {
    (section.questions || []).forEach((question) => {
      if (questionIsShown({
        answers, operatorData, question, section, sectionIndex,
      })) {
        questionUuids.add(question.uuid)
      }
    })

    return questionUuids
  }, new Set())
}

// An answer is only saved when the question it answers is rendered, so an
// answer is lost when its question is not shown by the version of the form
// used for the edit.  A question that is no longer on that version of the
// form is never shown, which covers questions and sections that were removed.
export const lostAnswerQuestions = ({
  answers, formVersionUsedInEdit, operatorData, submittedFormVersion,
}) => {
  const questionUuidsShown = shownQuestionUuids({ answers, formVersion: formVersionUsedInEdit, operatorData })

  return questionList(submittedFormVersion).filter((question) => (
    answerHasValue(answers[question.uuid]) && !questionUuidsShown.has(question.uuid)
  ))
}
